import {
  Incentive,
  useCurrencyOptions,
  useTranslateIncentiveText,
} from '@app/api';
import { CurrencyCodeSelect, Input, Select, SquareButton } from 'components';
import { useIncentiveEditionControllingState } from 'hooks/useIncentiveEditionControllingState';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';
import { FormEvent, useCallback } from 'react';

interface Props {
  incentive?: Incentive;
  onSubmit: (incentive: Incentive) => any;
}

const useStyles = createUseStyles((theme: Theme) => ({
  incentiveForm: {
    display: 'flex',
    gap: theme.marginBase,
    marginBottom: theme.marginBase,
  },
  line: {
    display: 'flex',
    gap: theme.marginBase,
  },
  incentive: {
    ...theme.fonts.caption,
    flex: 1,
    backgroundColor: theme.colors.grayBackground,
    padding: theme.marginBase,
    borderRadius: theme.borderRadius.std,
  },
  amountInput: {
    maxWidth: 120,
  },
}));

export const AdminIncentiveEdition = ({
  incentive: incentiveProps,
  onSubmit,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { incentive, onCurrencyChange, onAmountChange, floatAmount } =
    useIncentiveEditionControllingState(incentiveProps);
  const currenciesOptions = useCurrencyOptions();
  const editingIncentiveText = useTranslateIncentiveText(incentive);

  const onFormSubmit = useCallback(
    (e: FormEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onSubmit(incentive);
    },
    [onSubmit, incentive],
  );

  return (
    <form onSubmit={onFormSubmit}>
      <div className={classes.incentiveForm}>
        <Input
          label={t('editSession.public.incentive.amount')}
          value={floatAmount}
          noMargin
          onChange={onAmountChange}
          type="number"
          small
          containerClass={classes.amountInput}
        />
        <CurrencyCodeSelect
          label={t('editSession.public.incentive.currency')}
          value={incentive.currencyCode}
          options={currenciesOptions}
          noMargin
          onChange={onCurrencyChange}
          small
        />
      </div>
      <div className={classes.line}>
        <p id="referral-incentiveText" className={classes.incentive}>
          {editingIncentiveText || '/'}
        </p>
        <SquareButton color="blue" icon="ri-check-line" type="submit" />
      </div>
    </form>
  );
};
